import actionTypes from './actionTypes';

interface State {
	questions: { [name: string]: string; };
}
const initialState = {
	questions: {},
};
export default function questionReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.FETCH_QUESTION_SUCCESS:
			return { ...state, questions: action.questions };
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/questionReducer.ts